module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c2",
    attrs: {
      "id": "calibre_pb_1"
    }
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_vm._v("A PERMUTED PRESS book")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_vm._v("Published at Smashwords")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_vm._v("ISBN (Trade Paperback): 978-1-61868-398-4")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_vm._v("ISBN (eBook): 978-1-61868-397-7")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('i', {
    staticClass: "calibre4"
  }, [_vm._v("Carrier")]), _vm._v(" copyright © 2014")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_vm._v("by Timothy Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_vm._v("All Rights Reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_vm._v("Cover art by Jack Kaiser")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('i', {
    staticClass: "calibre4"
  }, [_vm._v("This")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("book")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("is")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("work")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("of")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("fiction")]), _vm._v(". "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("People")]), _vm._v(", "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("places")]), _vm._v(",\n"), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("events")]), _vm._v(", "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("and")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("situations")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("are")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("the")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("product")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("of")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("the")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("author’s")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("imagination")]), _vm._v(". "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("Any")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("resemblance")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("to")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("actual")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("persons")]), _vm._v(", "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("living")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("or")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("dead")]), _vm._v(",\n"), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("or")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("historical")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("events")]), _vm._v(", "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("is")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("purely")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("coincidental")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('i', {
    staticClass: "calibre4"
  }, [_vm._v("No")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("part")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("of")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("this")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("book")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("may")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("be")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("reproduced")]), _vm._v(", "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("stored")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("in")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("a")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("retrieval")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("system")]), _vm._v(", "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("or")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("transmitted")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("by")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("any")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("means")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("without")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("the")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("written")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("permission")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("of")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("the")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("author")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("and")]), _vm._v(" "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("publisher")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('img', {
    staticClass: "calibre5",
    attrs: {
      "alt": "tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM_html_m57db3c65.png",
      "id": "Picture_4",
      "src": "tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM_html_m57db3c65.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "c1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12420fc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_002.vue
// module id = 63
// module chunks = 0